import { getValueAtPath } from "../../../../../utils";
import ViewFactory from "../../../helpers/viewfactory";
import SuccessView from "../../../common/success";


export default function view() {
    const $this = this;
    const { $inputs, $timer } = this;

    $this.pollConfig = {
        onBegin() { $timer.start(); },
        onCancel() { $this.pollConfig.onComplete() },
        onSuccessful() { SuccessView && SuccessView.activate.call($this) },
        onComplete() {
            $timer.clear();
        }
    }

    return (view = ViewFactory({
        NAME: 'MOMO_MALAWI_CONFIRM_VIEW',
        mutables: {
            timerCurrent: 'CURRENT_TIME',
        },
        constants: {
            get phone() { return getValueAtPath($inputs, '[phone].value') }
        }
    }).call(this));
}